import { DebugRequestParamsDTO } from "@/types"
import context from "./context"

export function getDebugRequest(): DebugRequestParamsDTO | undefined {
  return context.mode.getDebugState()
}
